const scoredCategories = ['Growth Mindset', 'Communication', 'Professional Skills', 'Productivity', 'Commitment']

export { scoredCategories }
